// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__q_mT0","load6":"Spinner_load6__1a9Wi","round":"Spinner_round__qwaUN"};